import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../../AnimationContents';
import { ButtonController } from '../../../Common/ButtonController';
import { GameLogic } from '../../../Logic/GameLogic';
import { GameModel } from '../../../Models/GameModel';
import { DisplayObject, Graphics, Text, TextMetrics } from 'pixi.js';

export interface IDialogScreenControllerOptions {
    titleText: string;
    buttonText: string;
    onComplete: () => void;
    displayObject: DisplayObject | null;
}

export class DialogScreenController extends AnimationBaseController {
    public $model: GameModel;

    private _dialogWidth: number = 0;
    private _backgroundShape: Graphics;

    public constructor(
        @Inject private _options: IDialogScreenControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('DialogScreenController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.DIALOG_SCREEN_JSON,
            libraryName: 'dialog_window',
            childControllers: {
                btn_1: {
                    instanceName: 'button_1',
                    controller: ButtonController,
                    model: this.$model,
                    options: {
                        onClick: () => {
                            this._buttonAction();
                        },
                    },
                },
            },
        };
    }

    protected onInitialize(): void {
        this._setTextDialog(this._options.titleText);
        this._dialogWidth = this.width;
        this._backgroundShape = new Graphics();
        this.display.addChildAt(this._backgroundShape, 0);
        if (this.$model.showDialogRect) {
            this.container.addChild(this.$model.showDialogRect);
            console.log("rect", this.$model.showDialogRect);
        }

    }

    private _buttonAction(): void {
        if (this._options.onComplete) {
            this._options.onComplete();
        }
    }

    private _setTextDialog(state): void {
        this.gotoAndStop(2);
        this.setTextByQuery('title', `${this._options.titleText}`);
        this.setTextByQuery('button_1.button_1', `${this._options.buttonText}`);
        
    }

    protected onResize(width: number, height: number, scale: number) {
        const scaleValue = width / scale / this._dialogWidth;

        this.scaleX = scaleValue;
        this.scaleY = scaleValue;

        if (this._backgroundShape) {
            const w = width * 10;
            const h = height * 10;

            this._backgroundShape.clear();
            this._backgroundShape.beginFill(0x000000, 0.5);
            this._backgroundShape.drawRect(-w / 2, -h / 2, w, h);
            this._backgroundShape.endFill();
        }
    }

    protected onUpdate(frameRate: number) {
        const titleBounds = (this.getDisplayObjectByQuery('title')[0] as Text);
        const buttonBounds = (this.getDisplayObjectByQuery('button_1')[0] as Text);

        this.setTextCenter('button_1.button_1');
        this.setPosYByQuery('button_1', titleBounds.y + titleBounds.height + buttonBounds.height / 2 + 10);
    }

    private setTextCenter(key): void {
        this.setPosYByQuery(
            key,
            -(this.getDisplayObjectByQuery(key)[0] as Text).height / 2,
        );
    }
}
